export default __webpack_public_path__ + "static/media/NewFooterMob.991fa306.svg";